export const EVENT_INPUT_UPDATED = 'eventInputUpdated';
